import React from 'react'
import { QuestionUtils } from '../../utils/siteUtils'
import Section, { StyledBlock, StyledH2, StyledValue, StyledH3 } from './Section'
import { VehiclePageNumber, AftermarketPageNumber } from '../../constants'

const svgIcons = ['Stereo', 'Wheels & Tires', 'Suspension', 'Remote Start', 'Exhaust', 'Spoiler', 'Performance Modifications', 'Window Tint', 'Other']
const AftermarketEquipmentSection = ({ calculateViewChange, navigatePageWithState, prospectDocuments, getQuestionAnswerValues, isQuestionAnswered, getQuestionResponseComment, getQuestionResponse, canEdit, experienceState }) => {
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Aftermarket')
  const representativeQuestion = conditionQuestions && conditionQuestions.filter(question => question.item.toLowerCase().startsWith(svgIcons[0].toLowerCase()))[0]
  const answeredQuestions =
    conditionQuestions &&
    svgIcons.map(x => QuestionUtils.getAssociatedQuestions(conditionQuestions, QuestionUtils.translateName(x), representativeQuestion && representativeQuestion.subsectionCode).filter(x => isQuestionAnswered(x))).filter(x => !!x.length)

  const loaded = !!conditionQuestions
  let uniqueViewStr = 'uniqueViewStr:'
  const component = (
    <Section title="Vehicle Modifications" showEdit={canEdit} onClick={e => navigatePageWithState({ p: experienceState.isOfferCreationComponentDatEnabled ? VehiclePageNumber : AftermarketPageNumber }, { changeTitle: ' - Edit' })}>
      {answeredQuestions && !!answeredQuestions.length
        ? answeredQuestions.map((section, index) => {
            uniqueViewStr += section[0].subsection
            return (
              <StyledBlock key={index}>
                <StyledH2>{section[0].subsection}</StyledH2>
                {section.map((q, index2) => {
                  const comment = getQuestionResponseComment(q.questionId)
                  const answer = getQuestionAnswerValues(q)
                  const multi = q.questionType === 'MultiSelect' && answer.length
                  uniqueViewStr += q.label + (!multi && answer + comment)
                  const data = (
                    <React.Fragment key={index2}>
                      <StyledH3>{q.label}</StyledH3>
                      {multi ? (
                        q.selectChoices.map((choice, index3) => {
                          const answered = QuestionUtils.isQuestionAnswered(getQuestionResponse(choice.qRef).v)
                          const rcomment = answered && getQuestionResponseComment(choice.qRef)
                          uniqueViewStr += answered && choice.value + rcomment
                          const multiData = answered && (
                            <React.Fragment key={index3}>
                              <StyledValue>{choice.value}</StyledValue>
                              {rcomment && <StyledValue>Explanation: {rcomment}</StyledValue>}
                            </React.Fragment>
                          )
                          return multiData
                        })
                      ) : (
                        <>
                          <StyledValue>{answer}</StyledValue>
                          {comment && <StyledValue>Explanation: {comment}</StyledValue>}
                        </>
                      )}
                    </React.Fragment>
                  )
                  return data
                })}
              </StyledBlock>
            )
          })
        : 'No vehicle modification information entered'}
    </Section>
  )

  calculateViewChange && calculateViewChange('aftermarketEquipment', loaded && uniqueViewStr)
  return component
}

export default AftermarketEquipmentSection
